import { apiRequest } from "@core/services/api/apiRequest";

/**
 * Update the alt text for a media upload.
 *
 * @param mediaId - The ID of the media upload
 * @param altText - The new alt text value
 * @returns The updated media object
 */
export async function updateMediaAltText(
  mediaId: number,
  altText: string
): Promise<{ media_id: number; alt_text: string }> {
  const response = await apiRequest(
    `/uploads/${mediaId}/alt-text/`,
    "PATCH",
    { alt_text: altText },
    true
  );

  return response;
}

export default updateMediaAltText;
